<template>
  <header class="team-view-header">
    <div class="team-view-header__top">
      <TeamViewHeaderLogo
        class="team-view-header__logo"
        :value="team.logo"
        :disabled="isDisabled || !isEdit"
        @change="form.file = $event"
      />
      <div class="team-view-header__main">
        <h2 class="team-view-header__title">{{ team.name }}</h2>
        <div class="team-view-header__controls">
          <div v-if="cities" class="team-view-header__category">
            <div class="team-view-header__category-label">
              Город:
            </div>
            <AppSelect
              v-model="form.city_id"
              value-key="id"
              label-key="name"
              :options="cities"
              class="team-view-header__select"
              :disabled="isDisabled || !isEdit"
              :theme="isEdit ? 'second' : 'third'"
            ></AppSelect>
          </div>
          <template v-if="!isDisabled">
            <AppBtn
              v-if="isEdit"
              class="team-view-header__btn"
              color="third"
              :loading="loading"
              @click="save"
              >Сохранить</AppBtn
            >
            <AppBtn v-else class="team-view-header__btn" @click="startEdit"
              >Изменить</AppBtn
            >
          </template>
        </div>
      </div>
    </div>
    <div v-if="isApproved" class="team-view-header__message">
      Команда подтверждена.
    </div>
  </header>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { requestAlert, showAlert } from "@/core/common/";
import TeamViewHeaderLogo from "./TeamViewHeaderLogo";

export default {
  name: "TeamViewHeader",

  components: {
    TeamViewHeaderLogo
  },

  data: () => ({
    loading: false,
    form: null
  }),

  computed: {
    ...mapState("dictionaries", {
      cities: ({ dictionaries }) => dictionaries.cities
    }),
    ...mapState("team", ["team", "isEdit", "isOwnerMode"]),
    ...mapGetters("team", ["mainInfo", "isApproved", "isDisabled"])
  },

  watch: {
    mainInfo: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.isEdit) this.makeForm();
      }
    }
  },

  created() {
    if (!this.cities) this.getDictionary("cities");
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"]),
    ...mapMutations("team", ["startEdit"]),
    ...mapActions("team", ["saveChanges"]),

    makeForm() {
      this.form = { ...this.mainInfo, file: null };
    },

    async save() {
      this.loading = true;
      try {
        const { success, message } = await this.saveChanges(this.form);
        if (!success) {
          message ? showAlert(message) : requestAlert();
        }
      } catch (e) {
        requestAlert();
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.team-view-header {
  padding-bottom: 35px;
  border-bottom: 2px solid colors(palette-2);

  &__top {
    display: flex;
  }

  &__logo {
    flex-shrink: 0;
    margin-right: 20px;
  }

  &__main {
    padding-top: 10px;
    flex-grow: 1;
    max-width: calc(100% - 180px);
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 50px;
    font-weight: fw(bold);
    color: colors(palette-2);
    max-width: 100%;
    @include text-ellipsis();
    margin-bottom: 10px;
  }

  &__controls {
    display: flex;
    align-items: flex-end;
  }

  &__category {
    margin-right: 20px;
    flex-shrink: 0;
    width: 210px;
  }

  &__category-label {
    font-size: 24px;
    color: colors(text-2);
    text-transform: uppercase;
    font-weight: fw(bold);
    margin-bottom: 5px;
  }

  &__select,
  &__btn {
    height: 50px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: fw(bold);
    flex-shrink: 0;
  }

  &__select {
    width: 100%;
    border-radius: 4px;
  }

  &__btn {
    flex-grow: 3;
    max-width: 180px;
    margin-top: 15px;
  }

  &__message {
    color: colors(text-2);
    margin-top: 30px;
  }

  @include breakpoint("sm-and-down") {
    &__title {
      font-size: 35px;
    }
    &__category {
      margin-right: 0;
      width: 100%;
    }
    &__controls {
      flex-direction: column;
      align-items: flex-start;
    }
    &__btn {
      width: 100%;
    }
  }

  @media (max-width: 450px) {
    &__top {
      flex-direction: column;
    }
    &__main {
      max-width: 100%;
    }
    &__btn {
      max-width: none;
    }
  }
}
</style>
